<template>
  <div class="page-dh">
    <i class="el-icon-s-home"></i>
    <span v-for="(e,i) in route" :key="i">
      {{e.name}}
      <span class="ml5 mr5" v-if="i!==route.length-1">></span>
    </span>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  props: {
    route: {
    },
  },
  components: {
  },
  data() {
    return {

    };
  },
  mounted() {
  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
.page-dh {
  font-weight: 400;
  font-size: 14px;
  color: #767676;
}
</style>
